import { useState } from 'react';
import { AccountingAuditExport } from 'src/components/AccountingAudit/AccountingAuditExport';
import { OfficeDisplay } from 'src/components/common/OfficeDisplay';
import { useContent } from 'src/contexts/ContentContext';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { LaunchActivityLog } from 'src/modals/ActivityLog';
import { DownloadIcon, IconsFill } from 'src/svgs/Viagogo';
import { SaleDeeplinkQueryParam } from 'src/utils/constants/constants';
import { ContentId } from 'src/utils/constants/contentId';
import { getSaleDetailsModalConfigWithDeepLink } from 'src/utils/saleUtils';
import { Feature, Permission } from 'src/WebApiController';

import { ShareButton } from '../ShareButton/ShareButton';
import * as styles from './EventEntityHeader.css';
import { EntityIdNumberDiv, EntityInfoDiv } from './EventEntityHeader.styled';

export const SaleInfoDisplay = ({
  marketplace,
  entityId,
  idOnMkp,
  officeId,
}: {
  marketplace?: string | null;
  idOnMkp: string | null;
  entityId: number;
  officeId?: number | null;
}) => {
  const hasAccountingAuditExport = useUserHasFeature(
    Feature.AccountingAuditExport
  );
  const hasAccountingViewPermission = useUserHasAnyOfPermissions(
    Permission.Accounting_ViewAll,
    Permission.Accounting_ViewPaymentsOnSale
  );

  const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);
  const accountingExportTitle = useContent(ContentId.ExportAccountingData);

  return (
    <EntityInfoDiv>
      <div className={styles.entityInfoShareButtonIdNumberWrapper}>
        <ShareButton deepLinkQueryParam={SaleDeeplinkQueryParam} />
        <EntityIdNumberDiv>#{idOnMkp || entityId}</EntityIdNumberDiv>
      </div>
      <div className={styles.entityText}>{marketplace}</div>
      <OfficeDisplay officeId={officeId} />
      <LaunchActivityLog
        entityId={entityId}
        cancelTo={getSaleDetailsModalConfigWithDeepLink(entityId)}
      />
      {hasAccountingAuditExport && hasAccountingViewPermission && (
        <>
          <DownloadIcon
            withHoverEffect
            fill={IconsFill.currentColor}
            title={accountingExportTitle}
            onClick={() => setIsExportDialogOpen(true)}
          />
          <AccountingAuditExport
            entityId={entityId}
            isOpen={isExportDialogOpen}
            onClose={() => setIsExportDialogOpen(false)}
          />
        </>
      )}
    </EntityInfoDiv>
  );
};
